import _ from "lodash";
import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@toddle-edu/ds-web";
import classes from "./TruncatedTextWithTooltip.scss";

const TruncatedTextWithTooltip = ({ title }) => {
  const headerRef = useRef(null);

  return (
    <div ref={headerRef}>
      <Tooltip
        tooltip={<div className={classes.headerTooltip}>{title}</div>}
        placement="bottom"
        destroyTooltipOnScroll={false}
        getTooltipContainer={() => headerRef.current}
        visible={!_.isEmpty(title)}
      >
        <div>
          <div className={classes.modalHeader}>{title}</div>
        </div>
      </Tooltip>
    </div>
  );
};

TruncatedTextWithTooltip.propTypes = {
  title: PropTypes.string,
};

TruncatedTextWithTooltip.defaultProps = {
  title: "",
};

export default TruncatedTextWithTooltip;
